import React, { useCallback, useEffect, useState } from 'react';
import Table from '../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import { GetSubscriptionApi } from '../redux/actions/teams/members/GetSubscriptionActions';
import { GetDashboardStatsApi } from '../redux/actions/teams/members/GetDashboardStatsActions';
import { GetQuizFirstAttemptApi } from '../redux/actions/dashboard/GetQuizFirstAttemptAction';
import Pagination from '../components/Pagination';

const Dashboard = () => {
  const columns = ['Number of Subscription Plan','Plan Name', 'Amount(£)'];
  
  const { response: listResponse, loading: listLoading, error: listError } = useSelector((state) => state.subscriptionList);
  const { response: statsResponse, loading: statsLoading, error: statsError } = useSelector((state) => state.dashboardStats);
  const { response: quizStatsResponse, loading: quizStatsLoading, error: quizStatsError } = useSelector((state) => state.quizFirstAttemptStats);

  const dispatch = useDispatch();
  const [dataList, setDataList] = useState([]);
  const [quizStatsList, setQuizStatsList] = useState([]);
  const [quizCurrentPage, setQuizCurrentPage] = useState(1);
const [quizTotalPages, setQuizTotalPages] = useState(1);
const [quizTotalItems, setQuizTotalItems] = useState(0);
const [quizLimit, setQuizLimit] = useState(10);
const [quizSearchTerm, setQuizSearchTerm] = useState('');


// Update the dispatch call to a separate function
const fetchQuizStats = useCallback((page, limit, search) => {
    dispatch(GetQuizFirstAttemptApi(page, limit, search));
}, [dispatch]);



useEffect(() => {
    dispatch(GetSubscriptionApi());
    dispatch(GetDashboardStatsApi());
    fetchQuizStats(quizCurrentPage, quizLimit, quizSearchTerm);
}, [dispatch]);

// Re-fetch when page/limit/search changes
useEffect(() => {
    fetchQuizStats(quizCurrentPage, quizLimit, quizSearchTerm);
}, [quizCurrentPage, quizLimit, quizSearchTerm]);

  useEffect(() => {
    if (listResponse?.status) {
      setDataList(listResponse?.data || []);
    }
  }, [listResponse]);

// Update useEffect for quizStatsResponse
useEffect(() => {
    if (quizStatsResponse?.status) {
        setQuizStatsList(quizStatsResponse?.data?.stats || []);
        // setQuizCurrentPage(quizStatsResponse?.data?.currentPage);
        setQuizTotalPages(quizStatsResponse?.data?.totalPages);
        setQuizTotalItems(quizStatsResponse?.data?.totalItems);
    }
}, [quizStatsResponse]);

  const handleRetry = () => {
  window.location.reload(); // or trigger your data-fetching again
};

  const stats = statsResponse?.data || {};

    return (
        <div className="content-wrapper">
            <section className="main-section spacer-y">
                <div className="container">
                    <div className="row gy-4">
                         <div className="common_sub_heading_wrapper">
                                <h2>Users</h2>
                            </div>
                             {statsLoading ? (
                                          <div className="d-flex justify-content-center py-5"><PulseLoader color="#49a496" /></div>
                                        ) : statsError ? (
                                          <p className="text-danger">Failed to load stats</p>
                                        ) : (
                                          <>
                                            <div className="col-md-4 col-12">
                                                <div className="card shadow-sm p-3 d-flex flex-row justify-content-between align-items-center">
                                                    <div>
                                                        <h6 className="mb-1">Number of Users</h6>
                                                        <h4 className="mb-0">{stats.total_users}</h4>
                                                    </div>
                                                    <img
                                                    src="/assets/images/alluser.svg"
                                                    alt="Users"
                                                    style={{ width: "40px", height: "40px" }}
                                                    />
                                                </div>
                                            </div>
                                             {/* Subscribed Users */}
                                            <div className="col-md-4 col-12">
                                            <div className="card shadow-sm p-3 d-flex flex-row justify-content-between align-items-center">
                                                <div>
                                                <h6 className="mb-1">Subscribed Users</h6>
                                                <h4 className="mb-0">{stats.subscribed_users}</h4>
                                                </div>
                                                <img
                                                src="/assets/images/subscribeuser.svg"
                                                alt="Subscribed Users"
                                                style={{ width: "40px", height: "40px" }}
                                                />
                                            </div>
                                            </div>

                                            {/* Free Users */}
                                            <div className="col-md-4 col-12">
                                            <div className="card shadow-sm p-3 d-flex flex-row justify-content-between align-items-center">
                                                <div>
                                                <h6 className="mb-1">Free Users</h6>
                                                <h4 className="mb-0">{stats.free_users}</h4>
                                                </div>
                                                <img
                                                src="/assets/images/freuser.svg"
                                                alt="Free Users"
                                                style={{ width: "40px", height: "40px" }}
                                                />
                                            </div>
                                            </div>

                                            {/* Quiz Categories */}
                                            <div className="col-md-4 col-12">
                                            <div className="card shadow-sm p-3 d-flex flex-row justify-content-between align-items-center">
                                                <div>
                                                <h6 className="mb-1">Quiz Categories</h6>
                                                <h4 className="mb-0">{stats.total_quiz_category}</h4>
                                                </div>
                                                <img
                                                src="/assets/images/totalcategory.svg"
                                                alt="Quiz Categories"
                                                style={{ width: "40px", height: "40px" }}
                                                />
                                            </div>
                                            </div>

                                            {/* Total Quiz */}
                                            <div className="col-md-4 col-12">
                                            <div className="card shadow-sm p-3 d-flex flex-row justify-content-between align-items-center">
                                                <div>
                                                <h6 className="mb-1">Total Quiz</h6>
                                                <h4 className="mb-0">{stats.total_quiz}</h4>
                                                </div>
                                                <img
                                                src="/assets/images/totalquiz.svg"
                                                alt="Total Quiz"
                                                style={{ width: "40px", height: "40px" }}
                                                />
                                            </div>
                                            </div>

                                            {/* Revenue */}
                                            <div className="col-md-4 col-12">
                                            <div className="card shadow-sm p-3 d-flex flex-row justify-content-between align-items-center">
                                                <div>
                                                <h6 className="mb-1">Total Revenue</h6>
                                                <h4 className="mb-0">£{stats.total_revenue}</h4>
                                                </div>
                                                <img
                                                src="/assets/images/rev.svg"
                                                alt="Revenue"
                                                style={{ width: "40px", height: "40px" }}
                                                />
                                            </div>
                                            </div>
          
                                          </>
                                        )}
                         <div className="common_sub_heading_wrapper">
                                <h2>Subscription</h2>
                            </div>
                            <div className="tab-content common_tab_content" id="pills-tabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="pills-1"
                                    role="tabpanel"
                                    aria-labelledby="pills-1-tab"
                                    tabIndex="0"
                                >
                                    {listLoading ? (
                                        <div style={{ height: '40vh' }} className="d-flex align-items-center justify-content-center">
                                            <PulseLoader size={25} color="#49a496" />
                                        </div>
                                    ) : listError ? (
                                      
                                        <div className="center-container">
                                            <div className="error-box">
                                            <i className="bi bi-exclamation-triangle-fill"></i>
                                            <p>Something went wrong</p>
                                            <button className="retry-btn" onClick={handleRetry}>
                                                Try Again
                                            </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <Table
                                                tableData={dataList}
                                                setDataList={setDataList}
                                                columns={columns}
                                                title={'subscription'}

                                            />
                                        </>
                                    )}
                                </div>
                        </div>

      {/* Quiz First Attempt Scores */}
 <div className="common_sub_heading_wrapper mt-4 d-flex justify-content-between align-items-center">
    <h2>Quiz Scores (First Attempt Only)</h2>
</div> 

{/* Search */}
 <div className="mb-3 position-relative" style={{ maxWidth: '300px' }}>
    <input
        type="text"
        className="form-control ps-4"
        placeholder="Search quiz or user..."
        value={quizSearchTerm}
        onChange={(e) => {
            setQuizSearchTerm(e.target.value);
            setQuizCurrentPage(1);
        }}
    />
    <span className="position-absolute top-50 start-0 translate-middle-y ms-2">
        <i className="fas fa-search text-muted"></i>
    </span>
</div> 

 {quizStatsLoading ? (
    <div style={{ height: '40vh' }} className="d-flex align-items-center justify-content-center">
        <PulseLoader size={25} color="#49a496" />
    </div>
) : quizStatsError ? (
    <div className="center-container">
        <div className="error-box">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <p>Something went wrong</p>
            <button className="retry-btn" onClick={() => fetchQuizStats(quizCurrentPage, quizLimit, quizSearchTerm)}>
                Try Again
            </button>
        </div>
    </div>
) : (
    <>
        <Table
            tableData={quizStatsList}
            setDataList={setQuizStatsList}
            columns={['Quiz Name', 'User Name', 'Email', 'Score', 'Completed On']}
            title={'quizFirstAttempt'}
        />
        {quizStatsList?.length > 0 && (
            <Pagination
                currentPage={quizCurrentPage}
                totalPages={quizTotalPages}
                limit={quizLimit}
                totalItems={quizTotalItems}
                handlePageChange={(page) => setQuizCurrentPage(page)}
                handleLimitChange={(newLimit) => {
                    setQuizLimit(newLimit);
                    setQuizCurrentPage(1);
                }}
            />
        )}
    </>
)}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Dashboard;